function formatSavings(amountInCents) {
  const value = amountInCents / 100;
  // Prüfe, ob es eine ganze Zahl ist
  return Number.isInteger(value) ? value.toFixed(0) : value.toFixed(2);
}

document.addEventListener('DOMContentLoaded', function () {
  const variantSelect = document.querySelector('[name="id"]');
  const discountEl = document.querySelector('.zz-sale-badge-discount');

  if (!variantSelect || !discountEl || typeof window.variantDiscounts === 'undefined') return;

  const translation = discountEl.dataset.translation || 'Spare';

  function updateDiscount() {
    const selectedVariantId = variantSelect.value;
    const variantData = window.variantDiscounts[selectedVariantId];
    if (!variantData) return;

    const { price, compare_at_price } = variantData;
    const savings = compare_at_price - price;

    if (savings > 0) {
      const formattedSavings = formatSavings(savings);
      discountEl.innerHTML = `${translation} ${formattedSavings} CHF`;
      discountEl.style.display = 'block';
    } else {
      discountEl.style.display = 'none';
    }
  }

  updateDiscount();
  variantSelect.addEventListener('change', updateDiscount);
});